import PptxGenJS, * as PptxGenJSTypes from "pptxgenjs"
import { MasterSlide } from "../pptx-configuration/master-slides"
import * as PlaceholdersConfiguration from "../pptx-configuration/placeholders"
import { DocumentSection } from "../types"
import * as CommonUtils from "../utils"
import * as Conf from "../../configuration"
import * as Model from "../../../../model"
import * as DobGen from "../dob-generator/dob-generator"

const RATIO_BODY_TOP_OFFSET = CommonUtils.toInches(2)

export function checkDobSection(
	configuration: Conf.ReportConfiguration
): boolean {
	const dobtable = DobGen.checkDobTableSection(configuration)
	return dobtable		
}

export function createDobSection(
	pptx: PptxGenJS,
	configuration: Conf.ReportConfiguration,
	numbering: number[],
    years:number[],
    currentYear:number,
	scenario:Model.Scenario,
	loanDecompositions: Model.LoanDecomposition[],
	localAuthority:Model.LocalAuthority,
	loans: any,
	ppi:Model.Ppi
): DocumentSection {
	if (!checkDobSection(configuration)) return { slides: [], title: null }

	const title = CommonUtils.formatTitle(
		"Débat d'orientation budgétaire", numbering)
	const slides: PptxGenJSTypes.Slide[] = []
	const summarySlide = pptx.addNewSlide(MasterSlide.Default)
	summarySlide.addText(title, {
		placeholder: PlaceholdersConfiguration.Placeholder.Title
	})
	slides.push(summarySlide)

	const hasComparaisonSection = DobGen.checkDobTableSection(configuration);
		
	if (hasComparaisonSection) {
		const dobYears = []
		for (let y = currentYear - 1; y <= currentYear + 4; y++) {
			dobYears.push(y)
		}
		
		const comparaisonSection = DobGen.createDobTableSection(configuration,pptx,numbering,dobYears,currentYear,scenario,loanDecompositions,localAuthority,loans,ppi);
		comparaisonSection.slides.forEach(s=>slides.push(s));
    }
	return { slides, title }
    
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/dob-generator/index.tsx